export default "__VITE_ASSET__BmQLC2xz__"